module.exports = __webpack_public_path__ + "img/course_img.611a516d.jpg";